import { get } from 'lodash';

const styleMappings = {
    paragraph: 'p, ul, ol',
    'heading-one': 'h1',
    'heading-two': 'h2',
    'heading-three': 'h3',
    'heading-four': 'h4',
    link: 'p a, ul a, ol a',
    text: 'p, h1, h2, h3, h4, a',
    // text: 'p, ul, ol, h1, h2, h3, h4, a, span',
};

const generateInlineCSS = styles => {
    let css = '';
    for (let element in styles) {
        css += `${get(styleMappings, element, element)}{`;
        for (let key in styles[element]) {
            css += `${key}: ${styles[element][key]};`;
        }
        css += '}\n';
    }
    return css;
};

export default generateInlineCSS;
